import { create } from 'zustand'
import { persist } from 'zustand/middleware';

const storeSettings = (set) => ({
  allowedModules: [],
  setAllowedModules: (apps) => { set({ allowedModules: apps }) },
});

// const useStoreCurrentUser = create(storeSettings);
const useStoreCurrentUser = create(persist(storeSettings, { name: 'archem-mods', getStorage: () => sessionStorage, version: 0 }));

export default useStoreCurrentUser;